import React, { useEffect, useState } from 'react';
import EvaluateModal from './EvaluateModal';
import { useSelector } from 'react-redux';

interface EvaluateProps {
    evaluateData: any;
}

const extractKeys = (resources: any) => {
    let key_array: any = [];
    Object.keys(resources)?.forEach((key) => {
        key_array.push(key);
    });
    return key_array;
};

const Evaluate: React.FC<EvaluateProps> = ({ evaluateData }) => {
    const isOpenEvaluate = useSelector(
        (state: { EvaluateOpen: { isOpen: boolean } }) =>
            state.EvaluateOpen.isOpen
    );
    const extracted_keys = extractKeys(evaluateData?.data?.resources);

    return (
        <>
            {isOpenEvaluate && (
                <div className="z-30">
                    <EvaluateModal
                        resources={evaluateData?.data?.resources}
                        keys={extracted_keys}
                    />
                </div>
            )}
        </>
    );
};

export default Evaluate;
